export enum ConversationStatus {
    open = 'open',
    closed = 'closed',
    expired = 'expired',
    sleep = 'sleep',
}

export enum IdentityType {
    agent = 'agent',
    user = 'user',
    bot = 'bot',
    system = 'system',
    channel = 'channel',
}

export enum ConversationTabFilter {
    inbox = 'inbox',
    awaitAgent = 'awaitAgent',
    bot = 'bot',
    all = 'all',
    teams = 'teams'
}

export const getConversationRoomId = (conversation): string[] => {
    let socketRoom = [conversation.workspace._id]
    if (conversation.assignedToTeamId) { socketRoom.push(conversation.assignedToTeamId) }
    if (conversation.assignedToUserId) { socketRoom.push(conversation.assignedToUserId) }
    return socketRoom;
}

export enum ConversationCloseType {
    expiration = 'expiration',
    bot_finished = 'bot_finished',
    user_finished = 'user_finished',
    agent_finished = 'agent_finished',
    active_message_no_action = 'active_message_no_action',
}